module.exports = __webpack_public_path__ + "media/evolve/assets/icons/floorplans/door-mirrored-ac8d4e82f1493ce1c3f2cb1bc7599d26.svg";